/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq3a1Inputs */

const zh_pricing_faq3a1 = /** @type {(inputs: Pricing_Faq3a1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择年付方案将享受 20% 的折扣，按年一次性支付。`)
};

const en_pricing_faq3a1 = /** @type {(inputs: Pricing_Faq3a1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choosing a yearly plan gives you a 20% discount, billed as a single annual payment.`)
};

const es_pricing_faq3a1 = /** @type {(inputs: Pricing_Faq3a1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir un plan anual te da un 20% de descuento, facturado como un solo pago anual.`)
};

/**
* | output |
* | --- |
* | "Choosing a yearly plan gives you a 20% discount, billed as a single annual payment." |
*
* @param {Pricing_Faq3a1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq3a1 = /** @type {((inputs?: Pricing_Faq3a1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq3a1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq3a1(inputs)
	if (locale === "en") return en_pricing_faq3a1(inputs)
	return es_pricing_faq3a1(inputs)
});
export { pricing_faq3a1 as "pricing_faq3A" }